export enum InsuranceType {
  CAR = 'C',
  AUTO_LIFE = 'A',
  PROPERTY = 'Property',
  /** 取保險公司清單用的險種代碼（車險），保險系統只認 Property / Car / Warranty */
  CAR_STR = 'Car',
  WARRANTY = 'Warranty'
}
